import React from "react";
import { NavLink } from "react-router-dom";
import ResetLocation from "../../helpers/ResetLocation";
import FooterSocials from "./FooterSocials";

const FooterLegal = () => {
    return (
        <ul className="footer__menu  flex-container flex-column">
            <li>
                <NavLink
                    style={({ isActive }) =>
                        isActive
                            ? {
                                textDecoration: "none",
                                color: "#ff6240",
                            }
                            : {}
                    }
                    onClick={ResetLocation}
                    className="txt-white"
                    to="/careers"
                >
                    Karriere
                </NavLink>
            </li>
            <li>
                <NavLink
                    style={({ isActive }) =>
                        isActive
                            ? {
                                textDecoration: "none",
                                color: "#ff6240",
                            }
                            : {}
                    }
                    onClick={ResetLocation}
                    className="txt-white"
                    to="/privacy"
                >
                    Datenschutz
                </NavLink>
            </li>

            {/* <li>
                <NavLink
                    style={({ isActive }) =>
                        isActive
                            ? {
                                textDecoration: "none",
                                color: "#ff6240",
                            }
                            : {}
                    }
                    onClick={ResetLocation}
                    className="txt-white"
                    to="/refunds"
                >
                    Rückerstattungen
                </NavLink>
            </li> */}
            <li>
                <NavLink
                    style={({ isActive }) =>
                        isActive
                            ? {
                                textDecoration: "none",
                                color: "#ff6240",
                            }
                            : {}
                    }
                    onClick={ResetLocation}
                    className="txt-white"
                    to="/terms"
                >
                    AGB
                </NavLink>
            </li>
            <li>
                Partner:
            </li>
            <li className="txt-white">
            <FooterSocials />
            </li>

        </ul>
    );
}

export default FooterLegal;